import { ICOIExtractionInterface } from "@wingspanhq/shared-files/dist/lib/constants/extractions";
import { DataItemProps } from "../../../../../../shared/components/DataView";
import { toWSDateString } from "@wingspanhq/fe-component-library";
import { convertDateStringToUTCMidday } from "../../../../../../utils/dates";

export const mapCOIExtractedFieldsToDataView = (
  extractedFields: ICOIExtractionInterface
): DataItemProps[] => {
  const dataItems: DataItemProps[] = [
    {
      label: "Policy effective dates",
      value:
        [
          extractedFields?.effectiveDate
            ? toWSDateString(
                convertDateStringToUTCMidday(extractedFields.effectiveDate),
                "monthDayYear"
              )
            : null,
          extractedFields?.expirationDate
            ? toWSDateString(
                convertDateStringToUTCMidday(extractedFields.expirationDate),
                "monthDayYear"
              )
            : null
        ].join(" - ") || "N/A"
    },
    {
      label: "Issuing organization",
      value: extractedFields?.issuingOrganization
    }
  ];

  if (extractedFields?.certificateHolder) {
    dataItems.push({
      label: "Certificate holder",
      value: [
        extractedFields.certificateHolder.name,
        extractedFields.certificateHolder.address
      ]
        .filter(Boolean)
        .join("\n")
    });
  }

  if (extractedFields?.namedInsured) {
    dataItems.push({
      label: "Name insured",
      value: [
        extractedFields.namedInsured.name,
        extractedFields.namedInsured.address
      ]
        .filter(Boolean)
        .join("\n")
    });
  }

  if (extractedFields?.descriptionOfOperationsText) {
    dataItems.push({
      label: "Global details",
      value: extractedFields.descriptionOfOperationsText,
      fullWidth: true
    });
  }

  if (extractedFields?.cancellationNotice) {
    const firstPart = [
      extractedFields.cancellationNotice.noticePeriodDays
        ? `Notice period: ${extractedFields.cancellationNotice.noticePeriodDays} days`
        : null,
      extractedFields.cancellationNotice.noticeRecipient
        ? `Notice recipient: ${extractedFields.cancellationNotice.noticeRecipient}`
        : null
    ]
      .filter(Boolean)
      .join("\n");

    const secondPart = extractedFields.cancellationNotice.rawText
      ? `${extractedFields.cancellationNotice.rawText}`
      : "";

    dataItems.push({
      fullWidth: true,
      label: "Cancellation notice",
      value: [firstPart, secondPart].filter(Boolean).join("\n\n")
    });
  }

  return dataItems;
};
